<div class="flex w-full flex-col" [ngClass]="[containerClassName]">
  <!-- Top Section -->
  @if (title) {
    <div
      class="flex h-full flex-col items-center gap-2.5 rounded-3xl p-6 lg:items-start"
      [ngClass]="[
        sectionClassName,
        alwaysShowShadow
          ? 'shadow-card-top-hover-light'
          : 'group-hover:shadow-card-top-hover-light dark:group-hover:shadow-card-top-hover-dark',
      ]">
      <div class="flex w-full flex-col items-center justify-between gap-3 lg:flex-row">
        <div class="flex w-full flex-col items-center gap-8 rounded-3xl transition-transform lg:flex-row lg:items-start">
          <div class="flex w-full flex-col gap-6">
            <div class="flex flex-col gap-2">
              <span [ngClass]="titleClassName">{{ title }}</span>

              @if (subtitle) {
                <span [ngClass]="subtitleClassName">{{ subtitle }}</span>
              }

              @if (headerBadges) {
                <div class="flex gap-2.5">
                  @for (badge of headerBadges; track badge) {
                    <div class="flex items-center justify-center gap-2 rounded-lg border border-gray-200 bg-background px-2 py-0.5">
                      <span class="h-1.5 w-1.5 rounded-[50%]" [ngStyle]="{ background: badge.color }"></span>
                      <span class="text-[14px] text-secondary-foreground">{{ badge.title }}</span>
                    </div>
                  }
                </div>
              }
            </div>

            @if (features?.length) {
              <div class="flex flex-wrap gap-2">
                @for (feature of features; track feature) {
                  <span class="rounded-md border border-border bg-background px-3 py-1.5">{{ feature }}</span>
                }
              </div>
            }
            @if (showHeaderButtonBottom) {
              <button hlmBtn class="flex w-fit justify-start gap-2" [variant]="btnVariant">
                <span>{{ buttonText }}</span>
                <lucide-icon [name]="buttonIcon" size="20"></lucide-icon>
              </button>
            }
          </div>

          @if (suffixInlineSvgIcon) {
            <div class="relative h-[144px] w-[144px] shrink-0">
              <div class="absolute inset-0 rounded-full blur-lg" [ngStyle]="{ background: iconBgColor }"></div>
              <span
                [inlineSVG]="suffixInlineSvgIcon"
                class="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 text-foreground"></span>
            </div>
          }
        </div>
        @if (showHeaderButtonRight) {
          <div class="flex w-full justify-start lg:justify-end">
            <app-compound-button
              [title]="buttonText"
              [btnVariant]="btnVariant"
              [icon]="buttonIcon"
              (click)="onHeaderButtonClick()"></app-compound-button>
          </div>
        }
      </div>
    </div>
  }

  <!-- Middle 1 Section -->
  @if (description || (footerBadges && description)) {
    <div
      class="-mt-[1px] flex h-fit flex-col items-center gap-2 rounded-3xl p-6 lg:items-start"
      [ngClass]="[
        sectionClassName,
        alwaysShowShadow
          ? 'shadow-card-bottom-hover-light'
          : 'group-hover:shadow-card-bottom-hover-light dark:group-hover:shadow-card-bottom-hover-dark',
      ]">
      @if (description) {
        <div [ngClass]="descriptionClassName">{{ description }}</div>
      }

      @if (footerBadges && description) {
        <div class="flex w-full gap-3">
          @for (badge of footerBadges; track badge) {
            <div class="flex items-center gap-2">
              <lucide-icon [name]="badge.icon" size="20" class="text-tertiary-foreground"></lucide-icon>
              <span class="text-sm text-tertiary-foreground">{{ badge.title }}</span>
            </div>
          }
        </div>
      }
    </div>
  }

  <!-- Middle 2 Section -->
  @if (tableGridItems) {
    <div
      class="-mt-[1px] flex items-center rounded-3xl p-6"
      [ngClass]="[
        sectionClassName,
        alwaysShowShadow
          ? 'shadow-card-bottom-hover-light'
          : 'group-hover:shadow-card-bottom-hover-light dark:group-hover:shadow-card-bottom-hover-dark',
      ]">
      <div class="flex w-full flex-col">
        <!-- Table Headers -->
        <div class="flex rounded-xl bg-gray-200 px-4 py-2 font-medium">
          @for (header of tableGridItems.tableHeaders; track header) {
            <div class="w-1/2 font-medium">{{ header }}</div>
          }
        </div>

        <!-- Table Rows -->
        @for (row of tableGridItems.tableRows; track row) {
          <div class="flex border-b border-gray-200 px-4 py-2">
            @for (cell of row; track cell) {
              <div class="w-1/2 py-2 font-medium">{{ cell }}</div>
            }
          </div>
        }
      </div>
    </div>
  }

  <!-- Bottom Section -->
  @if (showButton) {
    <div
      class="-mt-[1px] flex items-center rounded-3xl p-6"
      [ngClass]="[
        sectionClassName,
        alwaysShowShadow
          ? 'shadow-card-bottom-hover-light'
          : 'group-hover:shadow-card-bottom-hover-light dark:group-hover:shadow-card-bottom-hover-dark',
      ]">
      <app-compound-button
        [title]="buttonText"
        [btnVariant]="btnVariant"
        [icon]="buttonIcon"
        (click)="onButtonClick()"></app-compound-button>
    </div>
  }
</div>
